import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-metrics-cards',
  templateUrl: './metrics-cards.component.html',
  styleUrls: ['./metrics-cards.component.scss'],
})
export class MetricsCardsComponent implements OnInit {

  @Input() title: string;
  @Input() data: string;
  constructor() { }

  ngOnInit() { }

}
